class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification-wrapper');
    this.drawer = document.getElementById('drawer');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('[data-cart-notification-close]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.drawer.classList.add('active');
    document.body.classList.add('overflow-hidden-tablet');
    this.notification.addEventListener(
      'transitionend',
      () => {
        trapFocus(this.notification, this.querySelector('[data-cart-notification-close]'));
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    this.drawer.classList.remove('active');
    document.body.classList.remove('overflow-hidden-tablet');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.classList.remove('cart-notification-wrapper--has-upsell');
    this.cartItemKey = parsedState.items ? parsedState.items[0].key : parsedState.key;
    let cartItemKeys = [];
    const isMultiple = parsedState.items != null;
    if(isMultiple) {
      cartItemKeys = parsedState.items.map(item => item.key);
    }
    const isUpsell = parsedState.items ? parsedState.items[0].properties['_original_product_id'] != undefined : parsedState.properties['_original_product_id'] != undefined;
    if(isUpsell) {
      this.classList.add('cart-notification-wrapper--has-upsell');
    }
    fetch(`/cart.js`)
    .then((response) => response.json())
    .then((cartData) => {
      let itemKeys = cartData.items.map(item => item.key).filter(itemKey => itemKey !== this.cartItemKey);
      if(isMultiple) {
        itemKeys = itemKeys.filter(itemKey => !cartItemKeys.includes(itemKey));
      }
      this.getSectionsToRender().forEach((section) => {
        const element = document.getElementById(section.id);
        if (element) {
          switch (section.id) {
            case 'cart-notification-product':
              element.innerHTML = '';
              if(isMultiple) {
                cartItemKeys.forEach((itemKey) => {
                  element.innerHTML += this.getSectionInnerHTML(parsedState.sections[section.id], `[id="cart-notification-product-${itemKey}"]`);
                })
              }
              else {
                element.innerHTML += this.getSectionInnerHTML(parsedState.sections[section.id], `[id="cart-notification-product-${this.cartItemKey}"]`);
              }
              itemKeys.forEach((itemKey) => {
                element.innerHTML += this.getSectionInnerHTML(parsedState.sections[section.id], `[id="cart-notification-product-${itemKey}"]`);
              });
              break;
            case 'cart-icon-bubble':
              element.innerHTML = '';
              element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
              break;
            case 'cart-notification-upsell':
              if(!isUpsell) {
                const newInnerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
                if(newInnerHTML.trim() !== '') {
                  this.classList.add('cart-notification-wrapper--has-upsell');
                }
                element.innerHTML = newInnerHTML;
              }
              break;
          }
        }
        this.open();
        this.querySelector('.cart-notification__body').scrollTop = 0;
      });
    })
    .catch((error) => {
      console.error('Error fetching cart data:', error);
    });
  }
  async refreshUpsellSection() {
    try {
      const upsellSection = document.getElementById('cart-notification-upsell');
      const cartResponse = await fetch(`/cart.js`);
      const cartData = await cartResponse.json();
      const firstCartItemKey = cartData.items[0].key;
      const sectionResponse = await fetch(`/?sections=cart-notification-upsell`);
      const sectionData = await sectionResponse.json();
      const responseUpsellSection = sectionData['cart-notification-upsell'];
      const newInnerHTML = this.getSectionInnerHTML(responseUpsellSection, `[id="cart-notification-upsell-${firstCartItemKey}"]`);
      if(newInnerHTML.trim() !== '') {
        upsellSection.innerHTML = newInnerHTML;
        this.classList.add('cart-notification-wrapper--has-upsell');
      }
    }
    catch (error) {
      console.error('Error fetching cart data:', error);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-notification-upsell',
        selector: `[id="cart-notification-upsell-${this.cartItemKey}"]`
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (element) {
      return element.innerHTML;
    } else {
      console.error(`Element with selector '${selector}' not found.`);
      return ''; 
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    const isCloseButton = target.closest('.cart-notification__close');
    const isDrawer = target.closest('.drawer');
    const isWithinWrapper = target.closest('.cart-notification-wrapper');
    
    if (isCloseButton) {
      this.close();
    } else if (isDrawer && !isWithinWrapper) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

class CartNotificationItem extends HTMLElement {
  constructor() {
    super();
    this.cartItemKey = this.dataset.cartItemKey;
    this.variantId = this.dataset.variantId;
    this._loading = false;

    this.cartNotification = this.closest('cart-notification');
    this.quantityInputEl = this.querySelector('quantity-input input');
    this.removeButton = this.querySelector('[data-cart-notification-remove]');
    this.lineItemTotalEl = this.querySelector('[data-cart-notification-line-price]');
    this.loadingSpinnerEl = this.querySelector('.loading__spinner');

    this.quantityInputEl.addEventListener('change', this.onQuantityChange.bind(this));
    this.removeButton.addEventListener('click', this.onRemove.bind(this));
  }
  set loading(value) {
    this._loading = value;
    this.classList.toggle('cart-notification-product--loading', value);
    this.loadingSpinnerEl.classList.toggle('hidden', !value);
  }
  get loading(){
    return this._loading;
  }
  onQuantityChange(e) {
    if(this.loading) return;
    this.loading = true;
    const newQuantity = parseInt(e.target.value);
    this.updateQuantity(newQuantity);
  }
  onRemove(e){
    if(this.loading) return;
    e.preventDefault();
    this.loading = true;
    this.updateQuantity(0);
  }
  async updateQuantity(newQuantity) {
    const changeData = {
      id: this.cartItemKey,
      quantity: newQuantity,
      sections: ['cart-icon-bubble', 'cart-notification-product']
    }
    const response = await fetch(`${routes.cart_change_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(changeData)
    });
    if (response.ok) {
      const responseData = await response.json();
      if(responseData.sections['cart-icon-bubble'] !== undefined){
        const cartIconBubble = document.querySelector('#cart-icon-bubble');
        const sectionHTML = new DOMParser().parseFromString(responseData.sections['cart-icon-bubble'], 'text/html');
        const newCartIconBubble = sectionHTML.querySelector('.shopify-section');
        if (cartIconBubble){
          cartIconBubble.innerHTML = newCartIconBubble.innerHTML;
        }
      }
      if(responseData.sections['cart-notification-product'] !== undefined){
        const sectionHTML = new DOMParser().parseFromString(responseData.sections['cart-notification-product'], 'text/html');
        const newNotificationProduct = sectionHTML.querySelector(`cart-notification-item[data-variant-id="${this.variantId}"]`);
        if(newNotificationProduct) {
          const newLineItemTotal = newNotificationProduct.querySelector('[data-cart-notification-line-price]');
          this.lineItemTotalEl.innerHTML = newLineItemTotal.innerHTML;
          this.cartItemKey = newNotificationProduct.dataset.cartItemKey;
        }
      }
      this.loading = false;
      if (newQuantity < 1) {
        this.remove();
        if(responseData.item_count < 1) {
          this.cartNotification.close();
        }
        else {
          await this.cartNotification.refreshUpsellSection();
        }
      }
    } 
    else {
      console.error('Failed to update cart item quantity');
      this.loading = false;
    }
  }
}
customElements.define('cart-notification-item', CartNotificationItem);